import React from 'react';

const Pulse = ({ text }) => {
  return (
    <div className="flex">
      {text.split('').map((char, index) => (
        <span
          key={index}
          className="animate-pulse"
          style={{
            animationDelay: `${index * 100}ms`,
          }}
        >
          {char}
        </span>
      ))}
    </div>
  );
};

export default Pulse;